import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get, invert } from 'lodash';
import { SORTING_ORDER_TYPES } from 'taboola-ultimate-ui';
import setCampaignGroupPickerSorting from 'modules/campaigns/actions/setCampaignGroupPickerSorting';
import CAMPAIGN_GROUP_SORTABLE_FIELDS, {
    defaultSortField,
    defaultSortType,
} from 'modules/campaigns/config/campaignGroupSortableFields';
import { campaignGroupPickerSortOptionsSelector } from 'modules/campaigns/selectors/campaignGroupManager';
import { useCurrentValueGetter } from '../../../hooks';

export const SORTABLE_FIELD_VALUE_TO_KEY_MAP = invert(CAMPAIGN_GROUP_SORTABLE_FIELDS);
export const SORTING_ORDER_TYPE_TO_KEY_MAP = invert(SORTING_ORDER_TYPES);

const getValidValue = (value, validValues, defaultValue) => (validValues[value] ? value : defaultValue);

export const useCampaignGroupPickerSorting = () => {
    const dispatch = useDispatch();
    const { type, field } = useSelector(campaignGroupPickerSortOptionsSelector);
    const sortField = getValidValue(field, SORTABLE_FIELD_VALUE_TO_KEY_MAP, defaultSortField);
    const sortType = getValidValue(type, SORTING_ORDER_TYPE_TO_KEY_MAP, defaultSortType);
    const sort = useMemo(
        () => [
            {
                field: sortField,
                order: sortType,
            },
            {
                field: CAMPAIGN_GROUP_SORTABLE_FIELDS.ID,
                order: SORTING_ORDER_TYPES.DESCENDANT,
            },
        ],
        [sortField, sortType]
    );
    const sortGetter = useCurrentValueGetter(sort);
    const setSort = useCallback(
        newSort => {
            const newField = get(newSort, '0.field');
            const newType = get(newSort, '0.order');

            if (newField) {
                dispatch(setCampaignGroupPickerSorting({ campaignGroupPickerSortingField: newField }));
            }
            if (newType) {
                dispatch(setCampaignGroupPickerSorting({ campaignGroupPickerSortingType: newType }));
            }
        },
        [dispatch]
    );

    return {
        sortField,
        sortType,
        sort,
        sortGetter,
        setSort,
    };
};
